import React from 'react';

interface EditIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
}

const EditIcon: React.FC<EditIconProps> = ({ 
  width = 14, 
  height = 14, 
  color = '#4C4C4C',
  className,
  style 
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={width} 
      height={height} 
      fill="none" 
      viewBox="0 0 14 14"
      className={className}
      style={style}
    >
      <path 
        d="M0.26709 11.2V4.80022C0.26709 4.43355 0.266834 4.13444 0.286621 3.89201C0.306805 3.6449 0.349698 3.4214 0.455892 3.21298C0.62206 2.8869 0.886979 2.62198 1.21305 2.45582C1.42147 2.34962 1.64498 2.30673 1.89209 2.28654C2.13452 2.26676 2.43362 2.26701 2.80029 2.26701H4.66683C4.88774 2.26701 5.06722 2.44584 5.06722 2.66675C5.06722 2.88767 4.88774 3.06649 4.66683 3.06649H2.80029C2.42047 3.06649 2.15951 3.06691 1.95719 3.08342C1.75949 3.09957 1.65313 3.12958 1.57633 3.16871C1.40076 3.25818 1.25826 3.40068 1.16878 3.57626C1.12965 3.65306 1.09964 3.75942 1.0835 3.95712C1.06699 4.15943 1.06657 4.42039 1.06657 4.80022V11.2C1.06657 11.5798 1.06699 11.8409 1.0835 12.0431C1.09964 12.2406 1.12963 12.3471 1.16878 12.4239C1.25839 12.5997 1.40102 12.7428 1.57633 12.8321C1.653 12.8711 1.75931 12.9006 1.95654 12.9168C2.15852 12.9332 2.41923 12.9337 2.79834 12.9337H9.20199C9.58123 12.9337 9.84192 12.9333 10.0438 12.9168C10.2407 12.9006 10.3467 12.8711 10.4233 12.8321C10.599 12.7426 10.7428 12.5988 10.8322 12.4233C10.8712 12.3466 10.9007 12.2406 10.9168 12.0437C10.9333 11.8418 10.9338 11.5811 10.9338 11.2019V9.33342C10.9338 9.1125 11.1126 8.93368 11.3335 8.93368C11.5544 8.93368 11.7332 9.1125 11.7332 9.33342V11.2019C11.7332 11.5679 11.7335 11.8668 11.7137 12.1088C11.6935 12.3555 11.6505 12.5783 11.5444 12.7865C11.3782 13.1128 11.1127 13.3782 10.7866 13.5444C10.5784 13.6504 10.3556 13.6935 10.1089 13.7136C9.86686 13.7334 9.56802 13.7332 9.20199 13.7332H2.79834C2.43241 13.7332 2.13354 13.7334 1.89144 13.7136C1.64465 13.6935 1.42132 13.6505 1.21305 13.5444C0.886836 13.3781 0.62194 13.1129 0.455892 12.7872C0.349718 12.5788 0.30681 12.3552 0.286621 12.1082C0.266836 11.8658 0.26709 11.5666 0.26709 11.2ZM10.4468 0.999435C10.602 0.896905 10.8127 0.914177 10.9494 1.05087L12.9494 3.05087C13.1056 3.20708 13.1056 3.45976 12.9494 3.61597L6.94938 9.61597C6.87437 9.69099 6.77292 9.73316 6.66683 9.73316H4.66683C4.44592 9.73316 4.26709 9.55433 4.26709 9.33342V7.33342C4.26709 7.22733 4.30926 7.12588 4.38428 7.05087L10.3843 1.05087L10.4468 0.999435ZM5.06657 7.49878V8.93368H6.50147L10.1017 5.33342L8.66683 3.89852L5.06657 7.49878ZM9.23193 3.33342L10.6668 4.76832L12.1017 3.33342L10.6668 1.89852L9.23193 3.33342Z" 
        fill={color}
      />
    </svg>
  );
};

export default EditIcon;

